export default __webpack_public_path__ + "static/css/05f89604a8e2c5611c16029e2412d50b.css";